import { jwtConfig } from '../../settings';

import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import tenantActions from '../tenants/actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';
import { getaddressConfig } from '../../settings';
import isEmpty from 'lodash/isEmpty';

/// DO2_LIST_PROPERTIES
const doListProperties = async () => {
  return await SuperFetch.post(apiUrls.listProperties)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* listProperties() {
  const response = yield call(doListProperties);
  if (response && !response.error) {
    yield put(actions.doListPropertiesSucceeded(response));
  }
}

/// DO2_GET_PROPERTY
const doGetProperty = async hash => {
  return await SuperFetch.post(`${apiUrls.getProperty}?phash=${hash}`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
const doGetPropertyHmo = async hash => {
  const body = {
    data: {
      propertyHash: hash
    }
  }
  return await SuperFetch.post(`${apiUrls.getPropertyHmo}`, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
const doGetPropertyDetails = async hash => {
  const body = {
    data: {
      propertyHash: hash
    }
  }
  return await SuperFetch.post(`${apiUrls.getPropertyDetails}`, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
const doGetPropertyImages = async hash => {
  return await SuperFetch.post(`${apiUrls.getPropertyImages}?propertyHash=${hash}`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
const doGetPropertyRental = async hash => {
  const body = {
    data: {
      propertyHash: hash
    }
  }
  return await SuperFetch.post(`${apiUrls.getPropertyRentalDetails}`, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getProperty(action) {
  const [
    address,
    hmo,
    details,
    images,
    rental
  ] = yield all([
    call(doGetProperty, action.hash),
    action.includedDetails.indexOf('hmo') >= 0 ? call(doGetPropertyHmo, action.hash) : null,
    action.includedDetails.indexOf('details') >= 0 ? call(doGetPropertyDetails, action.hash) : null,
    action.includedDetails.indexOf('images') >= 0 ? call(doGetPropertyImages, action.hash) : null,
    action.includedDetails.indexOf('rental') >= 0 ? call(doGetPropertyRental, action.hash) : null,
  ]);
  if (hmo && hmo.hmoData && hmo.hmoData.wholeRental === 0 && hmo.hmoData.hmoTenants && hmo.hmoData.hmoHouseholds) {
    yield put(actions.doHmoLookup({
      hmoHouseholds: parseInt(hmo.hmoData.hmoHouseholds),
      hmoTenants: parseInt(hmo.hmoData.hmoTenants),
      wholeRental: hmo.hmoData.wholeRental
    }));
  }
  if (address || hmo || details || images || rental) {
    yield put(actions.doGetPropertySucceeded({
      address: address.property,
      hmo: hmo ? hmo.hmoData : null,
      details: details ? details.propertyDetails : null,
      images: images ? images.images : null,
      rental
    }));
  } else {
    yield put(actions.doGetPropertyFailed({
      address,
      hmo,
      details,
      images,
      rental
    }));
  }
}

/// DO2_ADD_PROPERTY
const doAddProperty = async payload => {
  return await SuperFetch.post(apiUrls.addProperty, payload)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* addProperty(payload) {
  const response = yield call(doAddProperty, payload.payload);
  if (response) {
    yield put(actions.doAddPropertySucceeded(response));
    yield put(actions.doUpdateHmo({
      propertyHash: response.property.propertyHash,
      wholeRental: payload.payload.data.wholeRental,
    }))
  } else {
    yield put(actions.doAddPropertyFailed(response));
  }
}

/// DO2_UPDATE_PROPERTY
const doUpdateProperty = async (updateType, payload) => {
  let url = '';
  switch (updateType) {
    case 'address':
      url = apiUrls.updateProperty;
      break;
    case 'hmo':
      url = apiUrls.updatePropertyHmo;
      break;
    // we don't include images here
    // they are not updated via this action
    // but you can still request to load images
    // after the update action finishes
    // see getProperty 
    case 'details':
      url = apiUrls.updatePropertyDetails;
      break;
    case 'rentals':
      url = apiUrls.updatePropertyRentalDetails;
      break;
    default:
      url = apiUrls.updateProperty;
  }
  const data = {
    data: payload
  }
  return await SuperFetch.post(url, data)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* updateProperty(action) {
  const response = yield call(doUpdateProperty, action.updateType, action.payload);
  if (response) {
    const nextActions = [
      put(actions.doUpdatePropertySucceeded(action.updateType, response))
    ];
    if (action.reloadExtras) {
      nextActions.push(put(actions.doGetProperty(action.payload.propertyHash, action.reloadExtras)));
    }
    yield nextActions;
  } else {
    yield put(actions.doUpdatePropertyFailed(action.updateType, response));
  }
}

/// DO2_UPDATE_PROPERTY
const doUpdateHmo = async (payload) => {
  const data = {
    data: payload
  }
  return await SuperFetch.post(apiUrls.updatePropertyHmo, data)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* updateHmo(action) {
  const response = yield call(doUpdateHmo, action.payload);
  if (response) {
    yield put(actions.doUpdateHmoSucceeded(response))
    yield put(actions.doGetProperty(action.payload.propertyHash, ['hmo']))    
  } else {
    yield put(actions.doUpdateHmoFailed(response));
  }
}

// TODO
// write sagas for DO2_DELETE_PROPERTY

/// DO2_POSTCODE_LOOKUP
const doPostcodeLookup = async postcode => {
  return fetch(`${getaddressConfig.API_URL}${postcode}?api-key=${getaddressConfig.API_KEY}&sort=true`)
    .then((response) => response.json())
    .then((data) => data)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* postCodeLookup(action) {
  const response = yield call(doPostcodeLookup, action.payload);
  if (response && response.addresses && response.addresses.length) {
    yield put(actions.doPostcodeLookupSucceeded(response));
  } else {
    yield put(
      actions.doPostcodeLookupFailed(response)
    );
  }
}

/// DO2_HMO_LOOKUP
const doHmoLookup = async payload => {
  const body = {
    data: payload
  }
  return await SuperFetch.post(apiUrls.hmoLookup, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* hmoLookup(action) {
  const response = yield call(doHmoLookup, action.payload);
  if (response && !response.error) {
    yield put(actions.doHmoLookupSucceeded(response));
  } else {
    yield put(
      actions.doHmoLookupFailed(response)
    );
  }
}

/// DO2_EPC_LOOKUP
const doEpcLookup = async propertyHash => {
  const body = {
    data: {
      propertyHash
    }
  }
  return await SuperFetch.post(apiUrls.epcLookup, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* epcLookup(action) {
  const response = yield call(doEpcLookup, action.payload);
  if (response && !response.error) {
    yield put(actions.doEpcLookupSucceeded(response));
  } else {
    yield put(
      actions.doEpcLookupFailed(response)
    );
  }
}

/// DO2_LIST_PROPERTY_IMAGES
const doListPropertyImages = async payload => {
  return await SuperFetch.post(`${apiUrls.getPropertyImages}?propertyHash=${payload.data.propertyHash}`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* listPropertyImages(action) {
  const response = yield call(doListPropertyImages, action.payload);
  if (response && !response.error) {
    yield put(actions.doListPropertyImagesSucceeded(response));
  } else {
    yield put(actions.doListPropertyImagesFailed(response));
  }
}

/// DO2_ORDER_PROPERTY_IMAGES
const doOrderPropertyImages = async payload => {
  const postData = { data: payload.data };
  return await SuperFetch.post(`${apiUrls.reorderImages}?propertyHash=${payload.hash}&includeRemaining=1`, postData)
  .then(res => res)
  .catch(error => ({
    error: JSON.stringify(error)
  }));
}
function* orderPropertyImages(action) {
  const response = yield call(doOrderPropertyImages, action.payload);
  if (response && !response.error) {
    yield put(actions.doOrderPropertyImagesSucceeded(response));
  } else {
    yield put(actions.doOrderPropertyImagesFailed(response));
  }
}

// TODO
// write sagas for 

/// DO2_DELETE_PROPERTY_IMAGE
const doDeletePropertyImage = async payload => {
  const postData = { data: payload.data };
  return await SuperFetch.post(`${apiUrls.setImageDeleted}?includeRemaining=1`, postData)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* deletePropertyImage(action) {
  const response = yield call(doDeletePropertyImage, action.payload);
  if (response && !response.error) {
    yield put(actions.doDeletePropertyImageSucceeded(response));
  } else {
    yield put(actions.doDeletePropertyImageFailed(response));
  }
}

/// DO2_UPLOAD_PROPERTY_DOCUMENT
const doUploadPropertyDocument = async payload => {
  const body = new FormData();
  body.append('propertyHash', payload.hash)
  body.append('data', payload.file)
  body.append('expiryDate', payload.dateGasCertificateExpires)
  body.append('documentType','gas-certificate')

  return await fetch(apiUrls.propertyDocumentUpload, {
    body,
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('id_token')}`,
    },
  })
    .then(res => res.json())
    .then(res => res)
    .catch(error => error);
}
function* uploadPropertyDocument(action) {
  const response = yield call(doUploadPropertyDocument, action.payload);
  if (response && !response.error) {
    yield put(actions.doUploadPropertyDocumentSuccess(response));
    yield put(actions.doGetProperty(action.payload.hash, ['details', 'hmo']));
  } else {
    yield put(actions.doUploadPropertyDocumentFailed(response));
  }
}

const doRemovePropertyDocument = async payload => {
  const postData = { data: payload };
  return await SuperFetch.post(`${apiUrls.propertyDocumentRemove}`, postData)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* removePropertyDocument(action) {
  const response = yield call(doRemovePropertyDocument, action.payload);
  if (response && !response.error) {
    yield put(actions.doGetProperty(action.payload.propertyHash, ['details', 'hmo']));
  }
}

/// DO2_GET_RENTAL_DATA
const doGetRentalData = async hash => {
  const body =  {
    data: {
      hash
    }
  }
  return await SuperFetch.post(apiUrls.getRentalData, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getRentalData({ hash }) {
  const response = yield call(doGetRentalData, hash);
  if (response) {
    yield put(actions.doGetRentalDataSucceeded(response.rentalData));
  } else {
    yield put(actions.doGetRentalDataFailed(response));
  }
}

// DO2_ADD_RENTAL_DATA
const doAddRentalData = async (propertyHash, data) => {  
  const body = {
    data: {
      propertyHash,
      ...data
    }
  }
  return await SuperFetch.post(apiUrls.addRentalData, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* addRentalData({ payload }) {
  const { propertyHash, values } = payload;  
  const response = yield call(doAddRentalData, propertyHash, values);
  if (response) {
    yield* values.tenantsToInvite.map(function*(tenant) {
      const postData = {
        data: {
          tenantFirstname: tenant.tenantFirstname,
          tenantLastname: tenant.tenantLastname,
          tenantEmail: tenant.tenantEmail,
          rentalDataHash: response.rentalData.rentalDataHash,
          propertyHash: response.rentalData.propertyHash
        }
      }
      const res = yield put(tenantActions.doAddCurrentTenant(postData));
      console.log(response, res);
    });
    yield* values.tenantsToAdd.map(function*({ userId, tenancyEndDate }) {
      yield put(actions.doAddPropertyRentalTenant({ tenantId: userId, dateTenantTenancyEnd: tenancyEndDate.format("YYYY-MM-DD") }, response));
    });
    yield* values.tenantsToUpdate.map(function*({ userId, tenancyEndDate }) {
      yield put(actions.doUpdateTenantRentalLink({ tenantId: userId, dateTenantTenancyEnd: tenancyEndDate.format("YYYY-MM-DD") }, response));
    });
    yield* values.tenantsToRemove.map(function*({ userId, tenancyEndDate }) {
      yield put(actions.doRemovePropertyRentalTenant({ tenantId: userId, dateTenantTenancyEnd: tenancyEndDate.format("YYYY-MM-DD") }, response));
    });
    const shouldGetRentalData = ((payload.tenantsToAdd === undefined || payload.tenantsToAdd.length === 0) && (payload.tenantsToUpdate === undefined || payload.tenantsToUpdate.length === 0) && (payload.tenantsToRemove === undefined || payload.tenantsToRemove.length === 0));
    yield put(actions.doUpdateRentalDataSucceeded(response, shouldGetRentalData));
  } else {
    yield put(actions.doAddRentalDataFailed(response));
  }
}

// DO2_UPDATE_RENTAL_DATA
const doUpdateRentalData = async (data) => {
  const body = {
    data
  }
  return await SuperFetch.post(apiUrls.updateRentalData, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* updateRentalData({ payload }) {
  const response = yield call(doUpdateRentalData, payload);
  if (response) {
    yield* payload.tenantsToInvite.map(function*(tenant) {  
      const postData = {
        data: {
          tenantFirstname: tenant.tenantFirstname,
          tenantLastname: tenant.tenantLastname,
          tenantEmail: tenant.tenantEmail,
          rentalDataHash: tenant.rentalDataHash,
          propertyHash: tenant.propertyHash
        }
      }
      yield put(tenantActions.doAddCurrentTenant(postData));
    });
    yield* payload.tenantsToAdd.map(function*({ userId, tenancyEndDate }) {
      if (tenancyEndDate) {
        yield put(actions.doAddPropertyRentalTenant({ tenantId: userId, dateTenantTenancyEnd: tenancyEndDate.format("YYYY-MM-DD") }, response));
      }
    });
    yield* payload.tenantsToUpdate.map(function*({ userId, tenancyEndDate }) {
      if (tenancyEndDate) {
        yield put(actions.doUpdateTenantRentalLink({ tenantId: userId, dateTenantTenancyEnd: tenancyEndDate.format("YYYY-MM-DD") }, response));
      }
    });
    yield* payload.tenantsToRemove.map(function*({ userId }) {
      yield put(actions.doRemovePropertyRentalTenant({ tenantId: userId }, response));
    });
    const shouldGetRentalData = ((payload.tenantsToAdd === undefined || payload.tenantsToAdd.length === 0) && (payload.tenantsToUpdate === undefined || payload.tenantsToUpdate.length === 0) && (payload.tenantsToRemove === undefined || payload.tenantsToRemove.length === 0));
    yield put(actions.doUpdateRentalDataSucceeded(response, shouldGetRentalData));
  } else {
    yield put(actions.doAddRentalDataFailed(response));
  }
}

function* updateRentalDataSucceeded({ payload, shouldGetRentalData }) {
  if (shouldGetRentalData) {
    yield put(actions.doGetRentalData(payload.property.propertyHash));
  }
}

function* updateTenantRentalLinkSucceeded(response) {
  yield put(actions.doGetRentalData(response.payload.tenantRentalLink.propertyHash));
  yield put(actions.doGetPropertyRentalTenants(response.payload.tenantRentalLink.propertyHash));
}

function* removeTenantRentalLinkSucceeded(response) {
  yield put(actions.doGetRentalData(response.propertyHash));
  yield put(actions.doGetPropertyRentalTenants(response.propertyHash));
}

//DO2_GET_PROPERTY_RENTAL_TENANTS
const doGetPropertyRentalTenants = async (propertyHash) => {
  const body = {
    data: {
      propertyHash
    }
  };
  return await SuperFetch.post(apiUrls.getPropertyRentalTenants, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getPropertyRentalTenants({ payload }) {
  const response = yield call(doGetPropertyRentalTenants, payload);
  if (response) {
    yield put(actions.doGetPropertyRentalTenantsSucceeded(response));
  } else {
    yield put(actions.doGetPropertyRentalTenantsFailed(response));
  }
}

// DO2_ADD_PROPERTY_RENTAL_TENANT
const doAddPropertyRentalTenant = async (propertyHash, rentalDataHash, data) => {  
  const body = {
    data: {
      propertyHash,
      rentalDataHash,
      ...data
    }
  }
  return await SuperFetch.post(apiUrls.addPropertyRentalTenant, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* addPropertyRentalTenant({ payload }) {
  const { propertyHash, rentalDataHash, values } = payload;  
  const response = yield call(doAddPropertyRentalTenant, propertyHash, rentalDataHash, values);
  if (response) {
    yield put(actions.doAddPropertyRentalTenantSucceeded(response));
  } else {
    yield put(actions.doAddPropertyRentalTenantFailed(response));
  }
}

// DO2_UPDATE_TENANT_RENTAL_LINK
const doUpdateTenantRentalLink = async (propertyHash, rentalDataHash, data) => {
  const body = {
    data: {
      propertyHash,
      rentalDataHash,
      ...data
    }
  }
  return await SuperFetch.post(apiUrls.updateTenantRentalLink, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* updateTenantRentalLink({ payload }) {
  const { propertyHash, rentalDataHash, values } = payload;
  const response = yield call(doUpdateTenantRentalLink, propertyHash, rentalDataHash, values);
  if (response) {
    yield put(actions.doUpdateTenantRentalLinkSucceeded(response));
  } else {
    yield put(actions.doUpdateTenantRentalLinkFailed(response));
  }
}

// DO2_REMOVE_PROPERTY_RENTAL_TENANT
const doRemovePropertyRentalTenant = async (propertyHash, rentalDataHash, data) => {
  const body = {
    data: {
      propertyHash,
      rentalDataHash,
      ...data
    }
  }
  return await SuperFetch.post(apiUrls.removePropertyRentalTenant, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* removePropertyRentalTenant({ payload }) {
  const { propertyHash, rentalDataHash, values } = payload;
  const response = yield call(doRemovePropertyRentalTenant, propertyHash, rentalDataHash, values);
  if (response) {
    yield put(actions.doRemovePropertyRentalTenantSucceeded(response, propertyHash));
  } else {
    yield put(actions.doRemovePropertyRentalTenantFailed(response));
  }
}

// DO_GET_PROPERTY_SLOT_DATA
const doGetPropertySlotData = async payload => {
  const body = {
    data: {
      propertyHash: payload
    }
  }
  return await SuperFetch.post(apiUrls.getLandlordPropertySlotData, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getPropertySlotData(payload) {
  const response = yield call(doGetPropertySlotData, payload.payload);
  if (response) {
    yield put(actions.doGetPropertySlotDataSucceeded(response));
  } else {
    yield put(actions.doGetPropertySlotDataFailed(response));
  }
}

// DO_GET_ENQUIRY_GRAPH_DATA
const doGetEnquiryGraphData = async payload => {
  const body = {
    data: {
      ...payload
    }
  }
  return await SuperFetch.post(apiUrls.getEnquiryGraphAndData, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getEnquiryGraphData(action) {
  const response = yield call(doGetEnquiryGraphData, action.payload)
  if (response) {
    yield put(actions.doGetEnquiryGraphDataSucceeded(response));
  } else {
    yield put(actions.doGetEnquiryGraphDataFailed(response));
  }
}


export default function* rootSaga() {
  yield all([
    takeEvery(actions.DO2_LIST_PROPERTIES, listProperties),
    takeEvery(actions.DO2_GET_PROPERTY, getProperty),
    takeEvery(actions.DO2_ADD_PROPERTY, addProperty),
    takeEvery(actions.DO2_UPDATE_PROPERTY, updateProperty),
    takeEvery(actions.DO2_UPDATE_HMO, updateHmo),
    // takeEvery(actions.DO2_DELETE_PROPERTY, updateProperty),
    takeEvery(actions.DO2_POSTCODE_LOOKUP, postCodeLookup),
    takeEvery(actions.DO2_HMO_LOOKUP, hmoLookup),
    takeEvery(actions.DO2_EPC_LOOKUP, epcLookup),
    takeEvery(actions.DO2_LIST_PROPERTY_IMAGES, listPropertyImages),
    takeEvery(actions.DO2_ORDER_PROPERTY_IMAGES, orderPropertyImages),
    takeEvery(actions.DO2_DELETE_PROPERTY_IMAGE, deletePropertyImage),
    takeEvery(actions.DO2_UPLOAD_PROPERTY_DOCUMENT, uploadPropertyDocument),
    takeEvery(actions.DO2_REMOVE_PROPERTY_DOCUMENT, removePropertyDocument),
    takeEvery(actions.DO2_GET_RENTAL_DATA, getRentalData),
    takeEvery(actions.DO2_ADD_RENTAL_DATA, addRentalData),
    takeEvery(actions.DO2_UPDATE_RENTAL_DATA, updateRentalData),
    takeEvery(actions.DO2_GET_PROPERTY_RENTAL_TENANTS, getPropertyRentalTenants),
    takeEvery(actions.DO2_ADD_PROPERTY_RENTAL_TENANT, addPropertyRentalTenant),
    takeEvery(actions.DO2_UPDATE_TENANT_RENTAL_LINK, updateTenantRentalLink),
    takeEvery(actions.DO2_REMOVE_PROPERTY_RENTAL_TENANT, removePropertyRentalTenant),
    takeEvery(actions.DO_GET_PROPERTY_SLOT_DATA, getPropertySlotData),

    takeEvery(actions.DO2_UPDATE_TENANT_RENTAL_LINK_SUCCEEDED, updateTenantRentalLinkSucceeded),
    takeEvery(actions.DO2_ADD_PROPERTY_RENTAL_TENANT_SUCCEEDED, updateTenantRentalLinkSucceeded),
    takeEvery(actions.DO2_REMOVE_PROPERTY_RENTAL_TENANT_SUCCEEDED, removeTenantRentalLinkSucceeded),
    takeEvery(actions.DO2_UPDATE_RENTAL_DATA_SUCCEEDED, updateRentalDataSucceeded),

    takeEvery(actions.DO_GET_ENQUIRY_GRAPH_DATA, getEnquiryGraphData)
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/properties2/sagas.js